module.exports = __webpack_public_path__ + "media/bg.747622d6.mp3";